import { xanturaLogo } from "../../../assets/icons";

import { DropDown, useLegacySupport, Button } from "../../../components";
import { useMsal } from "@azure/msal-react";

import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import HeaderDropdown from "../../case-summary/components/headerDropdown";
import { getData, USER_DATA } from "../../../utils/Storage";
import { validateTokenBeforeApiCall } from "../../../utils/tokenUtils";

const TopHeader = (props: any) => {
  const legacy = useLegacySupport();
  const { t } = useTranslation();

  const { instance } = useMsal();

  const dspCodes: any = useSelector<any>((state) => state.dspCodes);

  const [dspData, setDspData] = useState<any>([]);
  const [dspSelectedItem, setDspSelectedItem] = useState<any>(null);
  const [userData, setUserData] = useState<any>(null);

  const handleCreateCaseClick = async () => {
    const isTokenValid = await validateTokenBeforeApiCall();
    if (!isTokenValid) {
      return;
    }
    props.onCreateCaseClick();
  };

  const handleGenerateMFAClick = async () => {
    const isTokenValid = await validateTokenBeforeApiCall();
    if (!isTokenValid) {
      return;
    }
    props.onGenerateMFA();
  };


  useEffect(() => {
    getData(USER_DATA).then((userData: any) => {
      if (userData !== null) {
        setUserData(userData);
      }
    })
  }, [])

  useEffect(() => {
    if (dspCodes.isSuccess && dspCodes.data !== null) {
      const data = dspCodes.data;
      if (data.defaultSelectedValue) {
        setDspSelectedItem(data.defaultSelectedValue);
      }

      const dspData = data.values.map((item: any, index: number) => {
        return {
          id: index,
          value: item.valueToStore,
          title: item.textToDisplay,
        };
      });
      setDspData(dspData);
    }
  }, [dspCodes]);

  return (
    <header className="top-header">
      <h1>
        <a href="/" title="Homepage">
          <img src={xanturaLogo} alt="Xantura logo" className="logo" />
        </a>
      </h1>
      <div className="button-wrapper">
        {!props.isReporting && props?.createCaseButton?.controlType === "button" ? <div className="filter-fields">
          <div className={"select-container"}>
            <div className="select-button-add">
              <button onClick={handleCreateCaseClick} type="button">{props.createCaseButton.controlLabel}</button>
            </div>
          </div>
        </div> : null}

        {
          (userData?.mfa === "EMAIL_MFA" && props.mfaQRButtonTitle && props.mfaQRButtonTitle !== "") &&
          <div className="filter-fields">
            <div className={"select-container"}>
              <div className="select-button-add">
                  <button onClick={handleGenerateMFAClick} type="button">{props.mfaQRButtonTitle} </button>
              </div>
            </div>
          </div>
        }


        <div className="dsp-dropdown">
          <DropDown
            label="Select Data Protocol"
            labelExternal={false}
            name={"selectCase"}
            data={dspData}
            defaultSelected={dspSelectedItem}
            isMultiSelectPickList={false}
            onChange={(e) => {
              if (e && e.length > 0) {
                setDspSelectedItem(e[0].value);
                props.onChange({ type: "dsp", value: e[0].value, title: e[0].title });
              }
            }}
          />
        </div>
        {/* <Button className="btn-cta blue-background" title={t("LOG_OUT")} onClick={() => __logout()} /> */}
        <HeaderDropdown label={props.username} labelExternal={false} />
      </div>
    </header>
  );
};

export default TopHeader;
